// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as UseSafeTimeout from "../../../../node_modules/@makerinc/use-safe-timeout/lib/es6_global/src/UseSafeTimeout.bs.js";
import * as IconCheck$Showside from "../icons/IconCheck.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as QuickViewButton$Showside from "./QuickViewButton.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
function ProductCardCTAButton(Props) {
  var sizeOpt = Props.size;
  var label = Props.label;
  var confirmation = Props.confirmation;
  var icon = Props.icon;
  var style = Props.style;
  var onClickOpt = Props.onClick;
  var disabledOpt = Props.disabled;
  var primaryOpt = Props.primary;
  var preventDefaultOpt = Props.preventDefault;
  var outlineOpt = Props.outline;
  var showConfirmationOpt = Props.showConfirmation;
  var wrapTextOpt = Props.wrapText;
  var controlledConfirmationOpt = Props.controlledConfirmation;
  var labelDataTestId = Props.labelDataTestId;
  var dataTestId = Props.dataTestId;
  var dataCount = Props.dataCount;
  var classNameOpt = Props.className;
  var onConfirmationEndOpt = Props.onConfirmationEnd;
  var tabIndex = Props.tabIndex;
  var size = sizeOpt !== undefined ? sizeOpt : /* Lg */1;
  var onClick = onClickOpt !== undefined ? onClickOpt : function (param) {};
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var primary = primaryOpt !== undefined ? primaryOpt : false;
  var preventDefault = preventDefaultOpt !== undefined ? preventDefaultOpt : false;
  var outline = outlineOpt !== undefined ? outlineOpt : true;
  var showConfirmation = showConfirmationOpt !== undefined ? showConfirmationOpt : false;
  var wrapText = wrapTextOpt !== undefined ? wrapTextOpt : false;
  var controlledConfirmation = controlledConfirmationOpt !== undefined ? controlledConfirmationOpt : false;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var onConfirmationEnd = onConfirmationEndOpt !== undefined ? onConfirmationEndOpt : function (param) {};
  ViewportContext$Showside.use(undefined);
  var match = React.useState(function () {
    if (disabled) {
      return "disabled";
    } else {
      return "neutral";
    }
  });
  var setStatus = match[1];
  var status = match[0];
  var match$1 = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var setStatusTimeout = match$1.setTimeout;
  var match$2 = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var setStatusAndConfirmationTimeout = match$2.setTimeout;
  React.useEffect(function () {
    Curry._1(setStatus, function (status) {
      if (status === "neutral" || status === "disabled") {
        if (disabled) {
          return "disabled";
        } else {
          return "neutral";
        }
      } else {
        return status;
      }
    });
  }, [disabled]);
  React.useEffect(function () {
    Curry._1(setStatus, function (status) {
      if (showConfirmation && controlledConfirmation && status === "neutral") {
        return "pending";
      } else {
        return status;
      }
    });
  }, [showConfirmation]);
  React.useEffect(function () {
    if (confirmation !== undefined && confirmation !== "") {
      setStatusTimeout(function (param) {
        Curry._1(setStatus, function (status) {
          if (status === "pending" && (showConfirmation || !controlledConfirmation)) {
            return "success";
          } else {
            return status;
          }
        });
      }, 1000);
      setStatusAndConfirmationTimeout(function (param) {
        Curry._1(setStatus, function (status) {
          if (status === "success") {
            return "neutral";
          } else {
            return status;
          }
        });
        Curry._1(onConfirmationEnd, undefined);
      }, 3000);
    }
  }, [status]);
  var onClick$1 = function (e) {
    if (preventDefault) {
      e.preventDefault();
      e.stopPropagation();
    }
    Curry._1(onClick, undefined);
    Curry._1(setStatus, function (status) {
      if (status === "neutral") {
        return "pending";
      } else {
        return status;
      }
    });
  };
  var tmp;
  switch (size) {
    case /* Sm */0:
      tmp = "p-2 font-semibold rounded-custom";
      break;
    case /* Lg */1:
      tmp = "py-5 font-semibold";
      break;
    case /* Md */2:
      tmp = "p-5 font-medium";
      break;
    case /* Xl */3:
      tmp = "py-5 px-20 font-semibold";
      break;
  }
  var className$1 = Cn.make([CSS$Showside.prefix("relative"), CSS$Showside.prefix("flex flex-grow items-center justify-center align-middle"), CSS$Showside.prefix("text-center"), wrapText ? "" : CSS$Showside.prefix("whitespace-nowrap"), CSS$Showside.prefix("text-lg"), primary ? CSS$Showside.prefix("bg-primary text-main") : CSS$Showside.prefix("bg-main text-primary"), CSS$Showside.prefix(tmp), CSS$Showside.prefix("dark-hover"), className]);
  var childrenCn = size !== 0 ? "flex items-center space-x-4" : "flex items-center space-x-3";
  var icon$1 = status === "success" ? Caml_option.some(React.createElement(IconCheck$Showside.make, {
    className: CSS$Showside.prefix(size !== 0 ? "w-5 h-5" : "w-4 h-4")
  })) : icon;
  var label$1 = status === "success" ? confirmation : label;
  var classMod = disabled ? CSS$Showside.prefix("pointer-events-none") : "";
  var border = outline ? React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["absolute inset-0 border border-solid rounded-inherit", primary ? "border-transparent" : "border-primary"]))
  }) : null;
  var disabledOverlay = disabled ? React.createElement("div", {
    className: CSS$Showside.prefix("absolute inset-0 rounded-inherit opacity-50 bg-main")
  }) : null;
  var renderChildren = function (param) {
    var tmp;
    if (label$1 !== undefined) {
      if (icon$1 !== undefined) {
        var tmp$1 = {
          children: React.createElement("div", undefined, label$1)
        };
        if (labelDataTestId !== undefined) {
          tmp$1.dataTestId = Caml_option.valFromOption(labelDataTestId);
        }
        tmp = React.createElement("div", {
          className: CSS$Showside.prefix(childrenCn)
        }, React.createElement("div", undefined, Caml_option.valFromOption(icon$1)), React.createElement(DataAttribute$Showside.make, tmp$1));
      } else {
        var tmp$2 = {
          children: React.createElement("div", undefined, label$1)
        };
        if (labelDataTestId !== undefined) {
          tmp$2.dataTestId = Caml_option.valFromOption(labelDataTestId);
        }
        tmp = React.createElement(DataAttribute$Showside.make, tmp$2);
      }
    } else {
      tmp = icon$1 !== undefined ? Caml_option.valFromOption(icon$1) : null;
    }
    return React.createElement("div", {
      className: disabled ? CSS$Showside.prefix("opacity-75") : ""
    }, tmp);
  };
  var tmp$1 = {
    className: className$1
  };
  if (style !== undefined) {
    tmp$1.style = Caml_option.valFromOption(style);
  }
  var tmp$2 = {
    className: Cn.make([classMod, CSS$Showside.prefix("flex flex-grow")]),
    onClick: onClick$1,
    children: React.createElement("div", tmp$1, renderChildren(undefined), border, disabledOverlay),
    hasText: true,
    disabled: disabled,
    dataId: primary ? "primary" : "secondary",
    ariaLive: "assertive"
  };
  var tmp$3 = size >= 3 ? {
    height: "70px"
  } : undefined;
  if (tmp$3 !== undefined) {
    tmp$2.style = Caml_option.valFromOption(tmp$3);
  }
  if (dataTestId !== undefined) {
    tmp$2.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  if (dataCount !== undefined) {
    tmp$2.dataCount = Caml_option.valFromOption(dataCount);
  }
  if (tabIndex !== undefined) {
    tmp$2.tabIndex = Caml_option.valFromOption(tabIndex);
  }
  return React.createElement(QuickViewButton$Showside.make, tmp$2);
}
ProductCardCTAButton.displayName = "ProductCardCTAButton";
var make = ProductCardCTAButton;
export { make };
/* react Not a pure module */